<template>
    <v-card>
        <v-card-text>
            <v-data-table :headers="headers" :items="project.severities" :items-per-page="10" sort-by="name">
                <template v-slot:top>
                    <v-toolbar flat color="transparent">
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" max-width="800px" persistent>
                            <template v-slot:activator="{ on }">
                                <v-btn rounded color="primary" dark v-on="on">
                                    {{ $t('buttons.createSeverity') }}
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline blue--text text--darken-1">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-text-field
                                        v-model="editSeverity.value"
                                        :counter="20"
                                        :label="$t('projects.severities.value')"
                                        required
                                        color="red"
                                    ></v-text-field>
                                    <v-color-picker
                                        v-model="editSeverity.color"
                                        hide-canvas
                                        hide-mode-switch
                                        show-swatches
                                        hide-inputs
                                        flat
                                        width="100%"
                                        height="200"
                                        class="mb-4"
                                    ></v-color-picker>
                                    <v-switch
                                        v-model="editSeverity.default"
                                        :label="$t('projects.severities.default')"
                                    ></v-switch>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="red darken-1" text @click="cancelEdit">
                                        {{ $t('buttons.cancel') }}
                                    </v-btn>
                                    <v-btn color="blue darken-1" text @click="save">
                                        {{ $t('buttons.save') }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>

                <template v-slot:[`item.value`]="{ item }">
                    <span :class="item.default ? 'subtitle-2' : ''">{{ $t('lists.severities.' + item.value) }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                    <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </template>
                <template v-slot:[`item.color`]="{ item }">
                    <v-avatar :color="item.color" size="36"> &nbsp; </v-avatar>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'project-setting-severities',
    data: () => ({
        dialog: false,
        editSeverity: {
            value: undefined,
            color: '#000000',
            default: false,
        },
    }),
    created() {},
    watch: {},
    computed: {
        ...mapGetters(['project']),
        headers() {
            return [
                {
                    text: '',
                    sortable: false,
                    value: 'color',
                    width: 36,
                },
                {
                    text: this.$t('projects.severities.value'),
                    sortable: true,
                    value: 'value',
                    sort: (a, b) => {
                        return this.$t('lists.severities.' + a).localeCompare(this.$t('lists.severities.' + b));
                    },
                },
                {
                    text: this.$t('projects.severities.actions'),
                    sortable: false,
                    value: 'actions',
                    width: 50,
                },
            ];
        },
        formTitle() {
            return this.editSeverity.value ? this.$t('title.editSeverity') : this.$t('title.newSeverity');
        },
    },
    methods: {
        ...mapActions(['updateSeverity', 'deleteSeverity']),
        cancelEdit() {
            this.dialog = false;
            this.editSeverity = {
                value: undefined,
                color: '#000000',
                default: false,
            };
        },
        editItem(item) {
            this.dialog = true;
            this.editSeverity.value = item.value;
            this.editSeverity.color = item.color;
            this.editSeverity.default = item.default;
        },
        deleteItem(item) {
            const severityToUpdate = {
                id: this.project.id,
                value: item.value,
            };

            this.deleteSeverity(severityToUpdate);
        },
        save() {
            const severityToUpdate = {
                id: this.project.id,
                value: this.editSeverity.value,
                color: this.editSeverity.color,
                default: this.editSeverity.default,
            };

            this.updateSeverity(severityToUpdate);
            this.cancelEdit();
        },
    },
};
</script>

<style></style>
